import React,{useState} from "react"
import stylesheet from "./prodetail.module.css"
import Header from "../../webincludes/header/index"
import Product_image1 from "../../../assets/images/weed_product.webp"
import bigbanner from "../../../assets/images/bigproductimage.webp"
import Product_image2 from "../../../assets/images/CBD2.webp"
import Product_image3 from "../../../assets/images/CBD3.webp"
import Product_image4 from "../../../assets/images/CBD4.webp"
import ProductCard from "../../webincludes/productcard/index"
import Input from "../../component/input/index"
import Button from "../../component/button/index"
import Footer from "../../webincludes/footer/index"
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";



const FadeLEFT = keyframes`
  from {
    opacity: 0;
    transform: translateX(500px);
  }

  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;



const ProductDetail = ()=>{
    const [currImage,setcurrImage]=useState(bigbanner)
    return(
        <>
        <div className={stylesheet.main_shop}>
            <div>
                <Header/>
            </div>
            <div className={`container-fluid ${stylesheet.product_side}`}>
                    <div className="row">
                    <div className={stylesheet.ShopCard_header}>
                        <div className="d-flex pl-5 pr-4 py-4">
                            <img src="https://img.icons8.com/material-outlined/20/f0cc00/left.png"/>
                        </div>
                        <div className="d-flex align-items-center">
                            <h6>home</h6><h6 className={stylesheet.navigation_breaker}>.</h6><h6 >Shop</h6><h6 className={stylesheet.navigation_breaker}>.</h6><h6 className={stylesheet.header_current_page}>Create</h6>
                        </div>
                    </div>
                    </div>
                    <div className="row">
                        <div className={`col-lg-6 ${stylesheet.category_section} pt-0 px-0`}>
                            <div className="row pt-5">
                                <div className={`col-lg-2 ${stylesheet.vertical_catelog}`}>
                                    <div className={stylesheet.small_banner}>
                                        <img onClick={()=>{setcurrImage(bigbanner)}} src={bigbanner} alt="" />
                                    </div>
                                    <div className={stylesheet.small_banner}>
                                        <img onClick={()=>{setcurrImage(Product_image2)}} src={Product_image2} alt="" />
                                    </div>
                                    <div className={stylesheet.small_banner}>
                                        <img onClick={()=>{setcurrImage(Product_image3)}} src={Product_image3} alt="" />
                                    </div>
                                    <div className={stylesheet.small_banner}>
                                        <img onClick={()=>{setcurrImage(Product_image4)}} src={Product_image4} alt="" />
                                    </div>
                                </div>
                                <div className={`col-lg-10 ${stylesheet.main_Image}`}>
                                    <Reveal keyframes={FadeLEFT} >
                                        <img src={currImage} alt="" />
                                    </Reveal>
                                </div>
                            </div>
                        </div>
                        <div className={`col-lg-6 p-5 ${stylesheet.productListing}`}>
                            <div className="py-5">
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    <h2>Created</h2>
                                    <h5>$34.90</h5>
                                </div>
                                <div className="d-flex align-items-center w-100">
                                    <h6>Flowers</h6>
                                </div>
                                <div className={stylesheet.pro_det_para}>
                                    <p>
                                    <b>Free yourself and start shaping your world</b><br></br>
                                    3.5 grams of exceptional CREATE Flowers rich in CBD that stimulate creativity and your capacity to break down boundaries, 100% natural and nicotine-free.
                                    </p>
                                </div>
                                <div className="d-flex align-items-center pt-5">
                                    <h6>Choose the quantity</h6>
                                    <select>
                                        <option>1</option>
                                        <option>2</option>
                                        <option>3</option>
                                        <option>4</option>
                                        <option>5</option>
                                        <option>6</option>
                                        <option>7</option>
                                    </select>
                                </div>
                                <div className="py-4">
                                    <Button value={"Add to Shopping Bag"}/>
                                </div>
                            </div>
                            <div className="py-5">
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    <h2>Features</h2>
                                </div>
                                <div className="py-4">
                                    <p>MA CREATE is a compact CBD Cannabis Flower characterized by a caramel color and subtle scent of fresh lemon and pine. Rich in CBD and energizing, our MA True Cannabis CREATE Flowers stimulate your natural energy, activate your creativity, eliminate stress, and boost your concentration.</p>
                                </div>
                            </div>

                            <div className="py-5">
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    <h2>Features</h2>
                                </div>
                                <div className="py-4">
                                    <p>MA CREATE is a compact CBD Cannabis Flower characterized by a caramel color and subtle scent of fresh lemon and pine. Rich in CBD and energizing, our MA True Cannabis CREATE Flowers stimulate your natural energy, activate your creativity, eliminate stress, and boost your concentration.</p>
                                </div>
                            </div>

                            <div className="py-5">
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    <h2>Features</h2>
                                </div>
                                <div className="py-4">
                                    <p>MA CREATE is a compact CBD Cannabis Flower characterized by a caramel color and subtle scent of fresh lemon and pine. Rich in CBD and energizing, our MA True Cannabis CREATE Flowers stimulate your natural energy, activate your creativity, eliminate stress, and boost your concentration.</p>
                                </div>
                            </div>

                            <div className="py-5">
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    <h2>Features</h2>
                                </div>
                                <div className="py-4">
                                    <p>MA CREATE is a compact CBD Cannabis Flower characterized by a caramel color and subtle scent of fresh lemon and pine. Rich in CBD and energizing, our MA True Cannabis CREATE Flowers stimulate your natural energy, activate your creativity, eliminate stress, and boost your concentration.</p>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
           <div>
           <Footer/>
           </div>
        </>
    )
}

export default React.memo(ProductDetail);